import { Button, FormControl, FormGroup, Modal, Row, ControlLabel } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "react-intl";
import FontAwesome from "react-fontawesome";
import React, { Component } from "react";
import validator from "../../Utils/Helpers/ValidationHelper";
import Auth from "../../Services/Auth/Auth";
import ValidationHelper from "../../Utils/Helpers/ValidationHelper";

class ForgotPasswordModal extends Component {
    _isMounted = true;

    constructor(props) {
        super(props);

        this.state = {
            clientKey: "",
            login: "",
            email: "",
            message: "",
            errorMsg: "",
            sending: false,
            visible: false
        };

        this.handleResetPasswordChange = this.handleResetPasswordChange.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.hideResetPasswordPopup = this.hideResetPasswordPopup.bind(this);
        this.checkEmail = this.checkEmail.bind(this);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(newProps) {
        if (newProps.visible !== undefined) {
            this.setState({ visible: newProps.visible });
        }
        if (newProps.clientKey !== undefined) {
            this.setState({ clientKey: newProps.clientKey });
        }
    }

    handleResetPasswordChange(e) {
        switch (e.target.id) {
            case "Login":
                this.setState({
                    login: e.target.value
                });
                break;
            case "Email":
                this.setState({
                    email: e.target.value
                });
                break;
            default:
        }
    }

    resetPassword(event) {
        if (event) event.preventDefault();

        this.setState({
            message: "",
            errorMsg: "",
            sending: true
        });

        const login = this.state.login;
        const email = this.state.email;
        const clientKey = this.state.clientKey;

        const isEmail = validator.isEmail(email);

        if (!isEmail) {
            this.setState({
                errorMsg: "E-mail inválido",
                sending: false
            });
            return;
        }

        Auth.passwordReset(login, email, clientKey, (success, message) => {
            if (this._isMounted) {
                if (!success) {
                    this.setState({
                        errorMsg: message,
                        sending: false
                    });
                    return;
                }

                this.setState({
                    message: message,
                    sending: false
                });
            }
        });
    }

    hideResetPasswordPopup() {
        this.setState({
            email: "",
            login: "",
            message: "",
            errorMsg: ""
        });
        this.props.hidePopup(); // chama a funcao do componente pai
    }

    checkEmail = () => {
        let fieldVal = this.state.email;

        if (!fieldVal) {
            return null;
        }

        if (fieldVal && !ValidationHelper.isEmail(fieldVal)) {
            return "error";
        }

        return "success";
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.hideResetPasswordPopup}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div>
                            <FormattedMessage id="password.reset" />{" "}
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <div className="card-form">
                            <form className="form-signin" onSubmit={this.resetPassword}>
                                <FormGroup controlId="Login">
                                    <ControlLabel>
                                        <FormattedMessage id="login" />:
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        value={this.state.login}
                                        autoFocus={!this.state.login}
                                        placeholder={this.props.intl.formatMessage({
                                            id: "login"
                                        })}
                                        onChange={this.handleResetPasswordChange}
                                    />
                                    <FormControl.Feedback />
                                </FormGroup>
                                <FormGroup controlId="Email" validationState={this.checkEmail()}>
                                    <ControlLabel>
                                        <FormattedMessage id="email" />:
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        value={this.state.email}
                                        placeholder={this.props.intl.formatMessage({
                                            id: "email"
                                        })}
                                        onChange={this.handleResetPasswordChange}
                                    />
                                    <FormControl.Feedback style={{ paddingTop: "5px" }} />
                                </FormGroup>
                                {this.state.errorMsg && <div className="alert alert-danger">{this.state.errorMsg}</div>}
                                {this.state.message && <div className="alert alert-success">{this.state.message}</div>}
                            </form>
                        </div>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        className="btn-primary"
                        style={this.state.clientStyle}
                        onClick={() => this.resetPassword()}
                        disabled={this.state.login === "" || this.state.email === "" || this.state.sending === true}
                    >
                        {this.state.sending && <FontAwesome name="spinner" spin />}{" "}
                        {!this.state.sending && <FontAwesome name="check" />} <FormattedMessage id="password.reset" />
                    </Button>
                    <Button className="btn-danger" onClick={this.hideResetPasswordPopup}>
                        <FontAwesome name="times" /> <FormattedMessage id="close" />
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default injectIntl(ForgotPasswordModal);
